// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import * as css from '../diferencias-inventarios/TablaInventarios.css'
import { InputOkCliente } from '../diferencias-inventarios/InputOkCliente.jsx'
import { InputOkSei } from '../diferencias-inventarios/InputOkSei.jsx'

export class RowInventario extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editando: false,
            editandoObservacion: false
        }
        this.onClick_editar = ()=>{
            this.setState({
                editando: true
            }, ()=>{
                this.inputStock.focus();
            })
        }
        this.onClick_editarObservacion = ()=>{
            this.setState({
                editandoObservacion: true
            }, ()=>{
                this.inputObservacion.focus();
            })
        }
        this.finalizarEdicion = ()=>{
            this.props.stockCliente(this.props.inventario.inv_idInventario, this.inputStock.value)
            this.setState({
                editando: false
            })
        }
        this.finalizarEdicionObservacion = ()=>{
            this.props.observacionCliente(this.props.inventario.inv_idInventario, this.inputObservacion.value)
            this.setState({
                editandoObservacion: false
            })
        }
        this.onKeyPress_editarStock = (evt)=> {
            if (evt.key == 'Enter') {
                evt.preventDefault()
                this.finalizarEdicion()
            }
        }
        this.onKeyPress_editarObservacion = (evt)=> {
            if (evt.key == 'Enter') {
                evt.preventDefault()
                this.finalizarEdicionObservacion()
            }
        }
    }
    render(){
        return (
            <tr key={1}>
                <td>{this.props.correlativo}</td>
                <td>{this.props.inventario.inv_fechaProgramadaF}</td>
                <td className={css.tdCeco}>{this.props.inventario.local_ceco}</td>
                <td>{this.props.inventario.local_nombre}</td>
                <td className={css.tdInf}>{this.props.inventario.inv_unidadesInformadas}</td>
                <td className={css.tdUnidadSEI}>{this.props.inventario.inv_diferenciaInfReal}</td>
                <td className={css.tdUnidadSEI}>{this.props.inventario.inv_unidadesReales}</td>
                <td className={css.tdUnidadCliente}>
                    {this.state.editando?
                        <input type="number"
                               ref={ref=>this.inputStock=ref}
                               defaultValue={this.props.inventario.inv_unidadesSegunCliente}
                               onKeyPress={this.onKeyPress_editarStock}
                               onBlur={this.finalizarEdicion.bind(this)}
                        />
                        :
                        <div>
                            {this.props.inventario.inv_aprobacionCliente == false ?
                                <div>
                                    {this.props.inventario.inv_unidadesSegunClienteFormato}
                                    <a onClick={this.onClick_editar.bind(this)}>
                                        <span className={'glyphicon glyphicon-edit pull-right'}></span>
                                    </a>
                                </div>
                                :
                                <div>
                                    {this.props.inventario.inv_unidadesSegunClienteFormato}
                                </div>
                            }
                        </div>
                    }
                </td>
                <td className={css.tdDiferencia}>{this.props.inventario.inv_diferenciaSEIClienteFormat}</td>
                <td className={css.tdObservacion}>
                    {this.state.editandoObservacion?
                        <input type="text"
                               ref={ref=>this.inputObservacion=ref}
                               defaultValue={this.props.inventario.inv_observacionDiferencia}
                               onKeyPress={this.onKeyPress_editarObservacion}
                               onBlur={this.finalizarEdicionObservacion.bind(this)}
                        />
                        :
                        <div>
                            {this.props.inventario.inv_aprobacionCliente == false ?
                                <div>
                                    {this.props.inventario.inv_observacionDiferencia}
                                    <a onClick={this.onClick_editarObservacion.bind(this)}>
                                        <span className={'glyphicon glyphicon-edit pull-right'}></span>
                                    </a>
                                </div>
                                :
                                <div>
                                    {this.props.inventario.inv_observacionDiferencia}
                                </div>
                            }
                        </div>
                    }
                </td>
                <td>{this.props.inventario.inv_hes}</td>
                <td className={css.tdOk}>
                    {this.props.permisos.aprobarUndCliente?
                        <InputOkCliente
                            permisos={this.props.permisos}
                            inventario={this.props.inventario}
                            aprobacionCliente={this.props.aprobacionCliente}
                        />
                        :
                        <input
                            type="checkbox"
                            checked={this.props.inventario.inv_aprobacionCliente}
                            disabled="true"
                        />
                    }
                </td>
                <td className={css.tdOk}>
                    {this.props.permisos.aprobarUndSEI ?
                        <InputOkSei
                            inventario={this.props.inventario}
                            aprobacionSei={this.props.aprobacionSei}
                        />
                        :
                        <input
                            type="checkbox"
                            checked={this.props.inventario.inv_aprobacionSEI}
                            disabled="true"
                        /> 
                    }    
                </td>
            </tr>
        )
    }
}
RowInventario.propTypes = {
    inventario: PropTypes.object,
    correlativo: PropTypes.number,
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func,
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/RowInventario.jsx